import { useCallback } from 'react';
import { AdobeDataType, adobeTracking } from '../../libs/track';

type UserInteractionData = AdobeDataType & {
  label?: string;
};

export function useUserInteractionTrack() {
  const trackUserInteraction = useCallback(
    ({ data }: { data: UserInteractionData }) =>
      adobeTracking({
        event: 'user interaction',
        data: {
          ...data,
        },
      }),
    []
  );

  return trackUserInteraction;
}
